import { devtools } from 'zustand/middleware';

/**
 *
 * Make devtools optional
 * 将是否开启 devtools 变成可选方案
 * @see https://github.com/pmndrs/zustand/discussions/1266
 */
export var optionalDevtools = function optionalDevtools(showDevTools) {
  return showDevTools ? devtools : function (f) {
    return f;
  };
};